module.exports = __webpack_public_path__ + "img/cases-brand-herborist-11.613d620b.jpg";